<template>
  <b-dropdown
    dropup
    :text="text + ' ' + this.$t('per page')"
    :variant="variant"
    :size="size"
    class="pagination-select"
  >
    <b-dropdown-item
      v-for="(item, index) in options"
      :key="index"
      @click="selected(index)"
      :active="item.value == value"
    >{{item.value}} {{$t("per page")}}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number
    },
    variant: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: () => ""
    }
  },
  mounted() {
    this.options.forEach((element, index) => {
      if (element.value == this.value) {
        this.selected(index);
      }
    });
  },
  data() {
    return {
      text: ""
    };
  },
  methods: {
    selected(index) {
      this.text = this.options[index].value;
      this.$emit("input", this.options[index].value);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
